// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__xlWLU","header":"MessagesList_header__SxuN_","chat":"MessagesList_chat__2TFC4"};